import { Waypoint } from '@omniafishing/core';
import { useVirtualizer } from '@tanstack/react-virtual';
import React from 'react';
import { useResponsive } from '../../../../hooks/use_responsive';
import { WaypointCard } from './waypoint_card';

interface WaypointsListProps {
  carouselHeight: number;
  onEditableWaypointChange: (waypoint: Waypoint | null, flyTo?: boolean) => void;
  onSelectedWaypointChange: (waypoint: Waypoint) => void;
  onWaypointDelete: (waypointId: number) => void;
  waypoints: Waypoint[];
}
export const WaypointsList = (props: WaypointsListProps) => {
  const {
    carouselHeight,
    onEditableWaypointChange,
    onSelectedWaypointChange,
    onWaypointDelete,
    waypoints,
  } = props;

  const { isDesktop } = useResponsive();
  const parentRef = React.useRef<HTMLDivElement>(null);

  const count = waypoints.length;
  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 63,
  });

  const items = virtualizer.getVirtualItems();
  const footerHeight = isDesktop ? 89 : 0;
  const height = carouselHeight - footerHeight;

  return (
    <div
      style={{
        height,
        overflow: 'auto',
      }}
      ref={parentRef}
    >
      <div
        style={{
          height: virtualizer.getTotalSize(),
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            transform: `translateY(${items[0]?.start ?? 0}px)`,
          }}
        >
          {items.map((item) => {
            const waypoint = waypoints[item.index];
            return (
              <div key={waypoint.id} data-index={item.index} ref={virtualizer.measureElement}>
                <WaypointCard
                  onSelectedWaypointChange={onSelectedWaypointChange}
                  onEditableWaypointChange={onEditableWaypointChange}
                  onWaypointDelete={onWaypointDelete}
                  waypoint={waypoint}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
